var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172.05 171.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 { fill: white; }\n      .cls-2 { fill: #fec514; }\n      .cls-3 { fill: #00bfb3; }\n      .cls-4 { fill: #f04e98; }\n      .cls-5 { fill: #1ba9f5; }\n      .cls-6 { fill: #93c90e; }\n      .cls-7 { fill: #07c; }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.05,89.79a33.85,33.85,0,0,0-22.39-31.93,48.11,48.11,0,0,0,.9-9.25,48.59,48.59,0,0,0-88-28.45,25.81,25.81,0,0,0-40,29.4A34.31,34.31,0,0,0,0,81.62a33.88,33.88,0,0,0,22.5,32,49.73,49.73,0,0,0-.89,9.24,48.46,48.46,0,0,0,87.86,28.26,25.77,25.77,0,0,0,40-29.29,34.29,34.29,0,0,0,22.57-32.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.64,73.81,105.29,91l38-33.28a42,42,0,0,0,.81-8.34,42.46,42.46,0,0,0-77.48-24L60.29,58.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.67,113.68a43.14,43.14,0,0,0-.83,8.47,42.57,42.57,0,0,0,77.77,23.94l6.27-32.67-8.37-16L65.72,80.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.44,48.53l25.8,6.09,5.65-29.34A20.38,20.38,0,0,0,28.44,48.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.2,54.67a28.74,28.74,0,0,0-19.55,27A28.44,28.44,0,0,0,25,108.28l36.2-32.72-6.65-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.23,146.09a20.35,20.35,0,0,0,31.39-23.2l-25.78-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M117.47,110.1l28.38,6.63a28.7,28.7,0,0,0,19.55-27,28.41,28.41,0,0,0-18.34-26.54L109.94,95.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElk);
export default __webpack_public_path__ + "static/media/elk.b54d4c651dbda45d24a57b141e94ad4c.svg";
export { ForwardRef as ReactComponent };